/**
 * Meta ads message-match: one editable entry per ad angle.
 * Duplicate the page and switch `adVersion` on <App /> to match the ad creative.
 */

export type AdVersion = 'A' | 'B' | 'C' | 'D'

export interface HeroCopy {
  label: string
  eyebrow: string
  /** Rendered as separate emphasis lines in the H1. */
  headline: string[]
  intro: string
  primaryCta: string
  secondaryCta: string
  microProof: string[]
}

const microProof = [
  'AI, automation, and CRM workflows designed for Arizona agents',
  'Built by real estate and technology leaders with 20+ years of experience',
  'Marketing support that keeps your business in motion',
]

const primaryCta = 'See How NEXT Supports Agents'
const secondaryCta = 'Book a Private Growth Call'
const eyebrow = 'For Arizona real estate agents'

export const heroVersions: Record<AdVersion, HeroCopy> = {
  A: {
    label: 'Agent Independence and Personal Brand',
    eyebrow,
    headline: ['Build your name.', 'Keep your freedom.', 'Let NEXT handle the systems behind your growth.'],
    intro:
      'HomeSmart NEXT gives agents the technology, AI, automation, marketing support, MLS-powered tools, and operational infrastructure needed to build a stronger business without having to build everything alone.',
    primaryCta,
    secondaryCta,
    microProof,
  },
  B: {
    label: 'AI, Automation, and Better Follow-Up',
    eyebrow,
    headline: ['Stop letting leads slip', 'through the cracks.', 'Practical AI and automation built for real estate.'],
    intro:
      'HomeSmart NEXT gives agents lead routing, nurture workflows, reminders, and AI-assisted follow-up that keep every conversation moving, without asking you to build the system yourself.',
    primaryCta,
    secondaryCta,
    microProof,
  },
  C: {
    label: 'Marketing and Consistent Visibility',
    eyebrow,
    headline: ['Your brand, in front of', 'your market, consistently.', 'NEXT runs the marketing systems behind it.'],
    intro:
      'HomeSmart NEXT supports agent branding, social content, creative, campaigns, and retargeting so your marketing keeps running while you stay focused on clients.',
    primaryCta,
    secondaryCta,
    microProof,
  },
  D: {
    label: 'Agent Support and Business Systems',
    eyebrow,
    headline: ['You do not need to build', 'every process alone.', 'Get the systems behind a stronger business.'],
    intro:
      'HomeSmart NEXT brings agents the tools, workflows, marketing support, data, and operational help that are hard to build as an individual agent.',
    primaryCta,
    secondaryCta,
    microProof,
  },
}
